<div class="TotemWidget TotemWidgetHero card">
    <div class="card-body TotemWidgetHero--' {{ size.toUpperCase() }} 
        {{ background || image ? 'TotemWidgetHero--WithBackground' : '' }} 
        bg-{{ background }}" 
        [style.backgroundImage]="image ? 'url(' + image + ')' : ''">
        @if(video) {
            <div class="TotemWidgetHero-Video TotemWidgetHero-Video--{{ videoLoadStatus == null ? 'Loading' : videoLoadStatus.toUpperCase() }} {{ isVideoPlaying ? 'TotemWidgetHero-Video--Playing' : ''}}"
                role="button"
                tabindex="0"
                [attr.aria-label]="'totem-a11y.video-play-pause' | locTranslate"
                (click)="togglePlayVideo()"
                (keydown.enter)="togglePlayVideo()"
                (keydown.space)="$event.preventDefault(); togglePlayVideo()">
                <video #videoElement [poster]="image" (canplaythrough)="videoLoadStatus = 'success'" (play)="isVideoPlaying = true;" (pause)="isVideoPlaying = false;">
                    <source [src]="video" type="video/mp4" (error)="videoLoadStatus = 'error'">
                </video>
            </div>
        }
        @else {
            @if (title) {
                <h3 class="TotemWidgetHero-Title card-title m-0">{{ title | locTranslate | stripHTML }}</h3>
            }
            @if (text) {
                <div class="TotemWidgetHero-Text card-text" [innerHTML]=" text | locTranslate "></div>
            }
            @if (buttons) {
                <div class="TotemWidgetHero-Buttons d-flex justify-content-center">
                    @for(button of buttons; track button) {
                        <button type="button" class="btn btn-{{ button.color&&!button.color.includes('#') ? button.color : 'primary' }} mx-1" (click)="onButtonClick(button)" [style.backgroundColor]="button.color.includes('#') ? button.color : null" [style.borderColor]="button.color.includes('#') ? button.color : null">
                            @if(button.icon) {
                                <i class="fa-regular {{ button.icon }}" aria-hidden="true"></i>
                            }
                            @if(button.text) {
                                <span>{{ button.text | locTranslate | stripHTML}}</span>
                            }
                        </button>
                    }
                </div>
            }
        }
    </div>
</div>
